import * as React from "react";
import CreateService from "../../service/create";
import PopDetail from "../popdetail";
import ReadService from "../../service/read";
import Wait from "../wait";
import {SpatialService} from "../../service/v1/spatial";

export default class CCROChangePartyPicturePane extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            srid: 0,
            villages: []
        }

        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.handleChangeFile = this.handleChangeFile.bind(this)
    }

    handleChanges=(e)=>{this.setState({[e.target.name]:e.target.value})}
    handleChangeFile=e=>{this.setState({ picture:e.target.files[0] })}

    render() {
        return(<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding:0}}>

                <table style={{width:'94%',margin:'2%'}}>
                    <tbody>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Select Picture</td>
                    </tr>
                    <tr>
                         <td>
                             <input type={'file'}  style={{width:'100%'}} accept=".jpg,.jpeg,.png" name={'picture'} onChange={this.handleChangeFile}/>
                         </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign:'center',width:'100%',float:'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Submit
                    </button>
                     <button className={'btn error'} onClick={()=>PopDetail.dismiss()}>
                        <span className={'fa fa-times'} style={{padding:0}}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }

    submit(){
        try{
            const formData = new FormData()
            formData.append('picture',this.state.picture)
            formData.append('extra',JSON.stringify({
                party_id:this.props.party.id,
                task_id:this.props.task_id,
                screen_code:this.props.screen_code
            }))

            Wait.show('Creating Layer...')
            SpatialService.updatePartyPicture(formData).then(d=>{
                Wait.dismiss()
                /*if (d.data.status===0){
                    alert(d.data.message)
                    return
                }*/
                this.props.loadData()
                PopDetail.dismiss()
            })




        }catch (e) {
             alert(e)
        }
    }


}